export const XEO_AUTHORIZATION_HEADER = 'xeo-authorization';
export const XEO_AUTHENTICATE_HEADER = 'xeo-www-authenticate';
export const XEO_AUTHENTICATE_CHALLENGE = 'Bearer';
